import { useBondPrincipalDropdowns } from "../bondPrincipalConfig";

export { BOND_PRINCIPAL_KIND } from "../bondPrincipalConfig";

/**
 * Shared dropdown + loading state for bond creation principal steps (VA, Trustee, Guardianship, Probate).
 * Field-specific layout and validation stay in each bond-type component.
 *
 * @param {object} options
 * @param {keyof typeof BOND_PRINCIPAL_KIND} options.kind
 * @param {number} options.attorneyLawFirmId — forwarded to `/lawfirm-attorneys/:id`
 * @param {boolean} [options.isGuest]
 */
export function useBondPrincipalForm({ kind, attorneyLawFirmId, isGuest }) {
  return useBondPrincipalDropdowns({ kind, attorneyLawFirmId, isGuest });
}
